import { render, staticRenderFns } from "./PostLanding.vue?vue&type=template&id=77912010&scoped=true&"
import script from "./PostLanding.vue?vue&type=script&lang=ts&"
export * from "./PostLanding.vue?vue&type=script&lang=ts&"
import style0 from "./PostLanding.vue?vue&type=style&index=0&id=77912010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77912010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
